export default __webpack_public_path__ + "static/media/google.3e437032.svg";